import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function DoneIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="u:check-circle">
          <path
            id="Vector"
            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
            fill="currentcolor"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
